export const LOCALSTORAGE_IDENTITY_PREFIX = 'ngtlanding.'
export const LOCALSTORAGE_IDENTITY_MS = 'ngtms.'
export const LOCALSTORAGE_IDENTITY_PORTAL = 'ngtportal.'
export const LOCALSTORAGE_IDENTITY_PREEMPTION = 'ngtpreemption.'
